import Item from '../partials/item';
import { res } from '../res';
import type { ActorArgs } from 'excalibur';
import { vec } from 'excalibur';
import { hints } from '../../stores';
import { hints as hText } from '../../texts';
import ScoreInformer from './score-informer';

export default class PointsBoost extends Item {
	static hintUsed = false;
	used = false;

	constructor(props: ActorArgs) {
		super({
			...props,
			name: 'points-boost',
			width: 94 - 20,
			height: 136 - 20,
		});
	}

	async use(): Promise<void> {
		if (this.used) return;
		this.used = true;

		if (!PointsBoost.hintUsed) {
			hints.add({
				img: `${this.name}.png`,
				text: hText[6],
			});

			PointsBoost.hintUsed = true;
		}

		const si = new ScoreInformer(
			{
				pos: this.pos.sub(vec(-this.width / 2, this.height)),
			},
			'score-boost',
		);

		this.scene.add(si);

		res.sounds.boost.play();
		super.use();
	}

	protected addGraphics() {
		this.graphics.use(res.scene.getFrameSprite('scene/points-boost'));
	}
}
